
define('text!app-SearchResults/modules/framework/viewCruise.html',[],function () { return '<div class="row">\n    \n    <div class="searchResults col-md-12">\n        \n        \n        <!--Search results will go here.-->\n    </div>\n</div>';});

